import React from "react";

const ShareOptionsModal = ({ isOpen, onClose, onShareNow, onSaveDraft, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50">
      <div className="bg-white w-full sm:w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl shadow-lg">
        {/* Modal Header */}
        <div className="px-6 py-4">
          <h3 className="text-lg font-semibold text-black">
            Ready to share?
          </h3>
        </div>

        {/* Modal Footer - Buttons */}
        <div className="border-t border-gray-150 flex flex-col">
          <button
            onClick={onShareNow}
            disabled={loading}
            className="w-full px-4 py-3 text-black disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex flex-col items-center justify-center"
          >
            <span className="font-semibold">Share Now</span>
            <span className="text-xs text-gray-600">Make your Post visible.</span>
          </button>

          <button
            onClick={onSaveDraft}
            disabled={loading}
            className="w-full px-4 py-3 border-t border-gray-150 text-black disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex flex-col items-center justify-center"
          >
            <span className="font-semibold">Share Draft for Review</span>
            <span className="text-xs text-gray-600">See what readers think before publishing.</span>
          </button>

          <button
            onClick={onClose}
            disabled={loading}
            className="w-full px-4 py-3 border-t border-gray-150 text-black disabled:opacity-50 disabled:cursor-not-allowed font-semibold transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareOptionsModal;